/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Required_NoticeInputs */



/**
* | output |
* | --- |
* | "Decklists are required for this tournament." |
*
* @param {Decks_Required_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_required_notice = /** @type {((inputs?: Decks_Required_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Required_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les decklists sont obligatoires pour ce tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las decklists son obligatorias para este torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Decklists são obrigatórias para este torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le decklist sono obbligatorie per questo torneo.")
	return /** @type {LocalizedString} */ ("Decklists are required for this tournament.")
});